module.exports = __webpack_public_path__ + "media/images/sp/brands/tvb/store_namba-83391e29f1ee425e03f1cd96a5135660.jpg";